function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MenuTemplate = require('./menu.template');
var _require = require('./listing-approval'),
  isStoreWeb3Active = _require.isStoreWeb3Active;
var Menu = /*#__PURE__*/function () {
  function Menu(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var callbacks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Menu);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.onNavigate = callbacks.onNavigate || null;
    this.onSell = callbacks.onSell || null;
    this.onSettings = callbacks.onSettings || null;
    this.onStoreModeChange = callbacks.onStoreModeChange || null;
    this.active = 'all';
    this.mode = 'browse';
    this.dashboardView = 'store-admin';
    this.has_store = false;
    this.store_check_done = false;
    this._checking_store = false;
    this.app.connection.on('store-listing-lifecycle', function (entry) {
      if ((entry === null || entry === void 0 ? void 0 : entry.phase) === 'complete' && !_this.has_store) {
        _this.has_store = true;
        _this.renderBrowseIfVisible();
      }
    });
    this.app.connection.on('store-profile-link-updated', function () {
      if (!_this.has_store) {
        _this.has_store = true;
        _this.renderBrowseIfVisible();
      }
    });
    this.app.connection.on('store-render-listings', function () {
      if (!_this.has_store && !_this.store_check_done) {
        void _this.refreshHasStore();
      }
    });
  }
  return _createClass(Menu, [{
    key: "renderBrowseIfVisible",
    value: function renderBrowseIfVisible() {
      if (this.mode === 'browse' && this.container) {
        this.render();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$mod$returnProfi, _this$mod;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      if (!this.has_store && this.mod.publicKey && (_this$mod$returnProfi = (_this$mod = this.mod).returnProfileStoreUrl) !== null && _this$mod$returnProfi !== void 0 && _this$mod$returnProfi.call(_this$mod)) {
        this.has_store = true;
      }
      var root = document.querySelector(this.container);
      if (root) {
        root.classList.toggle('marketplace', this.mode === 'browse');
        root.classList.toggle('dashboard', this.mode === 'dashboard');
      }
      var html = this.mode === 'dashboard' ? MenuTemplate.dashboard({
        dashboardView: this.dashboardView,
        showWithdrawals: isStoreWeb3Active(this.app)
      }) : MenuTemplate.browse({
        showMyStore: this.has_store
      });
      this.app.browser.replaceElementContentBySelector(html, this.container);
      if (this.mode === 'browse') {
        this.setActive(this.active);
        this.showModeration(this.mod.listings_to_moderate);
        if (!this.has_store) {
          void this.refreshHasStore();
        }
      }
      this.attachEvents();
    }

    /**
     * Update the existing Moderate row in place. Do not rebuild the menu.
     * count > 0 shows the item and badge; 0 hides the item (it stays in the DOM).
     */
  }, {
    key: "showModeration",
    value: function showModeration() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.container || this.mode !== 'browse') {
        return;
      }
      var root = document.querySelector(this.container);
      var item = root === null || root === void 0 ? void 0 : root.querySelector('#store-menu-moderate');
      if (!item) {
        return;
      }
      var pending = Math.max(0, Number(count) || 0);
      var badge = item.querySelector('[data-moderation-count]');
      if (pending > 0) {
        item.hidden = false;
        item.removeAttribute('aria-hidden');
        item.setAttribute('tabindex', '0');
        if (badge) {
          badge.textContent = String(pending);
        }
        return;
      }
      item.hidden = true;
      item.setAttribute('aria-hidden', 'true');
      item.setAttribute('tabindex', '-1');
      if (badge) {
        badge.textContent = '0';
      }
    }

    /**
     * Show "My Saito Store" when the user already has a storefront (Profile URL
     * or at least one listing). Reuses returnProfileStoreUrl + loadListingsPage.
     */
  }, {
    key: "refreshHasStore",
    value: function () {
      var _refreshHasStore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$returnProfi2, _this$mod2, _this$mod$main, _storefront$activeSum;
        var storefront, _ref, _result$pagination$to, _result$pagination, _result$listings, _require2, loadListingsPage, result, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.has_store || this._checking_store || this.store_check_done)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (this.mod.publicKey) {
                _context.n = 2;
                break;
              }
              this.store_check_done = true;
              return _context.a(2);
            case 2:
              if (!((_this$mod$returnProfi2 = (_this$mod2 = this.mod).returnProfileStoreUrl) !== null && _this$mod$returnProfi2 !== void 0 && _this$mod$returnProfi2.call(_this$mod2))) {
                _context.n = 3;
                break;
              }
              this.has_store = true;
              this.renderBrowseIfVisible();
              return _context.a(2);
            case 3:
              storefront = (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.manager) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.storefront;
              if (!(storefront !== null && storefront !== void 0 && storefront.inventoryLoaded && storefront.publicKey === this.mod.publicKey && ((_storefront$activeSum = storefront.activeSummaries) === null || _storefront$activeSum === void 0 ? void 0 : _storefront$activeSum.length) > 0)) {
                _context.n = 4;
                break;
              }
              this.has_store = true;
              this.renderBrowseIfVisible();
              return _context.a(2);
            case 4:
              if (this.mod.store_public_key) {
                _context.n = 5;
                break;
              }
              return _context.a(2);
            case 5:
              this._checking_store = true;
              _context.p = 6;
              _require2 = require('./browse-listings'), loadListingsPage = _require2.loadListingsPage;
              _context.n = 7;
              return loadListingsPage(this.app, this.mod, {
                public_key: this.mod.publicKey,
                category: '',
                offset: 0,
                page_size: 1
              });
            case 7:
              result = _context.v;
              total = Number((_ref = (_result$pagination$to = result === null || result === void 0 || (_result$pagination = result.pagination) === null || _result$pagination === void 0 ? void 0 : _result$pagination.total) !== null && _result$pagination$to !== void 0 ? _result$pagination$to : result === null || result === void 0 || (_result$listings = result.listings) === null || _result$listings === void 0 ? void 0 : _result$listings.length) !== null && _ref !== void 0 ? _ref : 0);
              this.store_check_done = true;
              if (total > 0) {
                this.has_store = true;
                this.renderBrowseIfVisible();
              }
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t = _context.v;
            case 9:
              _context.p = 9;
              this._checking_store = false;
              return _context.f(9);
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[6, 8, 9, 10]]);
      }));
      function refreshHasStore() {
        return _refreshHasStore.apply(this, arguments);
      }
      return refreshHasStore;
    }()
  }, {
    key: "setMode",
    value: function setMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browse';
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$dashboardView = _ref2.dashboardView,
        dashboardView = _ref2$dashboardView === void 0 ? this.dashboardView : _ref2$dashboardView,
        storeMode = _ref2.storeMode;
      this.mode = mode === 'dashboard' ? 'dashboard' : 'browse';
      if (storeMode === 'sold') {
        this.dashboardView = 'sold';
      } else if (storeMode === 'active') {
        this.dashboardView = dashboardView === 'active' ? 'active' : 'store-admin';
      } else if (dashboardView) {
        this.dashboardView = ['store-admin', 'active', 'sold', 'withdrawals'].includes(dashboardView) ? dashboardView : 'store-admin';
      }
      this.render();
    }
  }, {
    key: "setDashboardView",
    value: function setDashboardView() {
      var dashboardView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store-admin';
      this.dashboardView = ['store-admin', 'active', 'sold', 'withdrawals'].includes(dashboardView) ? dashboardView : 'store-admin';
      if (this.mode !== 'dashboard' || !this.container) {
        return;
      }
      this.setActive(this.dashboardView);
    }

    /** @deprecated Prefer setDashboardView — kept for callers that still pass storeMode. */
  }, {
    key: "setStoreMode",
    value: function setStoreMode() {
      var storeMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'active';
      this.setDashboardView(storeMode === 'sold' ? 'sold' : 'store-admin');
    }
  }, {
    key: "setActive",
    value: function setActive() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.mode === 'dashboard') {
        this.dashboardView = ['store-admin', 'active', 'sold', 'withdrawals'].includes(view) ? view : this.dashboardView;
      } else {
        this.active = view;
      }
      if (!this.container) {
        return;
      }
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var current = this.mode === 'dashboard' ? this.dashboardView : this.active;
      root.querySelectorAll('.item').forEach(function (item) {
        if (item.dataset.action) {
          item.classList.remove('active');
          item.removeAttribute('aria-current');
          return;
        }
        var on = item.dataset.view === current;
        item.classList.toggle('active', on);
        item.setAttribute('aria-current', on ? 'page' : 'false');
      });
    }
  }, {
    key: "activate",
    value: function activate(item) {
      if (item.dataset.action === 'list-item') {
        if (typeof this.onSell === 'function') {
          this.onSell();
        }
        return;
      }
      if (item.dataset.action === 'settings') {
        if (typeof this.onSettings === 'function') {
          this.onSettings();
        }
        return;
      }
      var view = item.dataset.view || '';
      var category = item.dataset.category != null ? item.dataset.category : undefined;
      this.setActive(view);
      if (typeof this.onNavigate === 'function') {
        this.onNavigate(view, {
          category: category
        });
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.item').forEach(function (item) {
        item.onclick = function (e) {
          e.preventDefault();
          _this2.activate(item);
        };
        item.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this2.activate(item);
          }
        };
      });
    }
  }]);
}();
module.exports = Menu;